import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-surface">
      <Header />
      <main className="flex-1 max-w-7xl mx-auto w-full px-page py-8">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
